<template>
  <div class="d-lg-flex half">
    <div class="bg order-1 order-md-2" style="background-image: url('../assets/media/photos/office.png');"></div>
    <div class="contents order-2 order-md-1">

      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-md-7">
            <h3>
              Войти в
              <span class="font-size-xl text-dual-primary-dark logo-font">Debt</span>
              <span class="font-size-xl text-primary logo-font">Ster</span>
            </h3>
            <form @submit.stop.prevent="signIn">
              <div class="form-group first">
                <label for="username">Логин</label>
                <input
                    type="text" class="form-control"
                    placeholder="Введите логин"
                    id="username"
                    v-model="auth.login">
              </div>
              <div class="form-group last mb-3">
                <label for="password">Пароль</label>
                <input
                    type="password"
                    class="form-control"
                    placeholder="Введите пароль"
                    id="password"
                    v-model="auth.password">
              </div>

              <div class="d-flex mb-5 align-items-center" v-if="ip">
                <label for="login-remember-me">Ваш IP-адрес: {{ ip }}</label>
              </div>

              <button type="submit" class="btn btn-block btn-primary">
                <i class=" mr-10"
                   :class="{ 'si si-login': !isProcessing, 'fa fa-circle-o-notch fa-spin fa-fw': isProcessing }"></i>
                Войти
              </button>

            </form>
          </div>
        </div>
      </div>
    </div>


  </div>

</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      auth: {
        login: '',
        password: '',
      },
      errors: {},
      ip: '',
      isProcessing: false,
    };
  },
  mounted() {
    this.getIpAddress();
  },
  methods: {
    async signIn() {
      try {
        this.isProcessing = true;
        await this.$store.dispatch('SIGNIN', this.auth)
        await this.$store.dispatch('GET_AUTH_USER');
        await this.$store.dispatch('LOGIN_ACTIVITY');
        this.$router.push('/');
      } catch (err) {
        //
      } finally {
        this.isProcessing = false;
      }
    },
    async getIpAddress() {
      try {
        const { data } = await window.axios.get('ip');
        this.ip = data.ip;
      } catch (err) {
        throw err;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/login";
</style>
